export const urlDecorator = (url) => {
    let fullUrl = url;

    const urlOrigin = window.location.origin;

    if (fullUrl.charAt(0) !== '/' && urlOrigin.charAt(urlOrigin.length - 1) !== '/') {
        fullUrl = `/${fullUrl}`;
    }

    if (fullUrl.startsWith('http') === false) {
        fullUrl = `${window.location.origin}${fullUrl}`;
    }

    // console.log('fullUrl', fullUrl);

    try {
        fullUrl = new URL(fullUrl);

        if (window.config?.show_translation_keys === true) {
            fullUrl.searchParams.set('show_translation_keys', true);
        }

        if (window.config?.translate === true) {
            fullUrl.searchParams.set('translate', true);
        }
    } catch (e) {
        console.error(e);
        return url;
    }

    return fullUrl.toString();
};
